module.exports = __webpack_public_path__ + "img/ZJ5255.213dbd58.png";